// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { vmiUsersImportModalStyles } from "@vanmeter/Overrides/Components/VmiUsersImportModal";
import { fontConfig } from "@vanmeter/XDL/constants";
import { createLinkIconStyles, mergeWithCss, modalButtonsActionStyles, xScreen } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";

vmiUsersImportModalStyles.instructionText = {
    ...fontConfig.smallSingleLine,
};

vmiUsersImportModalStyles.templateLink = {
    ...createLinkIconStyles({
        icon: "Download",
        sizeVariant: "small",
        linkStyles: {
            css: css`
                margin-top: 12px;
                display: block;
            `,
        },
    }),
};

vmiUsersImportModalStyles.cancelUploadButton = {
    ...modalButtonsActionStyles.cancelButton,
};

vmiUsersImportModalStyles.instructionGridItem = { width: 12 };

vmiUsersImportModalStyles.uploadInputGridItem = {
    width: 12,
    css: css`
        order: 2;
    `,
};

vmiUsersImportModalStyles.controlsGridItem = {
    width: 12,
    css: css`
        padding: 0;
        display: block;
    `,
};

vmiUsersImportModalStyles.buttonsWrapper = {
    ...mergeWithCss(modalButtonsActionStyles.buttonsGridItem, {
        css: css`
            ${xScreen("lte", "sm")} {
                flex-direction: column;
                gap: 12px;
            }
        `,
    }),
};

vmiUsersImportModalStyles.fileUploader = {
    mergeCss: true,
    buttonProps: {
        variant: "secondary",
    },
};
